<template>
  <div class="tarificador-personalizado p-4">
    <h2 class="mb-4 text-dark font-weight-bold">Tarificador de Costos de Suplementos por Cliente</h2>
    <p class="text-muted">
      Configure y guarde los costos base originales de los suplementos que su cliente verá reflejados en las
      cotizaciones.
    </p>

    <!-- Selección de Cliente -->
    <div class="card mb-4 shadow-sm rounded bg-white">
      <div class="card-body p-3">
        <div class="form-group row align-items-center mb-0">
          <label for="cliente-select" class="col-sm-3 col-form-label font-weight-bold text-dark">
            Cliente a Configurar:
          </label>
          <div class="col-sm-9">
            <select id="cliente-select" class="form-control" v-model="clienteSeleccionadoId">
              <option disabled value="">Seleccione un cliente...</option>
              <option v-for="c in clientes" :key="c.id" :value="c.id">{{ c.nombre }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- Edición de suplementos -->
    <div v-if="clienteSeleccionadoId">
      <h3 class="mt-4 mb-3 text-dark">Edición de Costos de Suplementos</h3>
      <div v-for="(transportista, tKey) in tarifas" :key="tKey" class="card mb-4 shadow-sm rounded">
        <div class="card-header bg-dark text-white font-weight-bold h5 py-2 px-3">
          {{ transportista.nombre }}
        </div>
        <div class="card-body p-3 bg-white">

          <div class="container-fluid">

            <!-- Header desktop -->
            <div class="row d-none d-md-flex font-weight-bold text-secondary pb-2 mb-2 border-bottom">
              <div class="col-md-4">Suplemento / Concepto</div>
              <div class="col-md-4">Tipo de Valor</div>
              <div class="col-md-4">Costo</div>
            </div>

            <!-- Item -->
            <div v-for="(sup, sKey) in transportista.suplementos" :key="sKey" class="row py-3 px-1 mb-2 rounded"
              style="border: 1px solid #eaeaea;">

              <!-- Concepto -->
              <div class="col-md-4 mb-3 mb-md-0">
                <div class="d-md-none text-muted small mb-1">Suplemento / Concepto</div>
                <div class="font-weight-bold text-dark" style="font-size: 1rem;">
                  {{ sup.concepto }}
                </div>
              </div>

              <!-- Tipo Valor -->
              <div class="col-md-4 mb-3 mb-md-0">
                <div class="d-md-none text-muted small mb-1">Tipo de Valor</div>
                <select class="form-control" v-model="sup.tipoValor">
                  <option value="MONEDA">Moneda ($)</option>
                  <option value="PORCENTAJE">Porcentaje (%)</option>
                </select>
              </div>

              <!-- Costo -->
              <div class="col-md-4 mb-1 mb-md-0">
                <div class="d-md-none text-muted small mb-1">Costo</div>
                <div class="input-group" style="height: 40px;">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-light font-weight-bold" style="font-size: 1rem;">
                      {{ sup.tipoValor === 'MONEDA' ? '$' : '%' }}
                    </span>
                  </div>
                  <input type="number" class="form-control" style="font-size: 1rem;" min="0"
                    v-model.number="sup.costoOriginal" />
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
      <div class="text-right mt-3">
        <button class="btn btn-primary btn-lg" @click="guardarCostos" v-b-tooltip.hover.top="'Guarda los costos configurados para este cliente'">
          Guardar Cambios
        </button>
      </div>
    </div>

    <div v-else class="alert alert-info mt-4 shadow-sm rounded">
      Por favor, seleccione un cliente para editar sus costos de suplementos.
    </div>
  </div>
</template>

<script>
export default {
  name: "TarificadorPersonalizado",
  data() {
    return {
      clienteSeleccionadoId: "",
      clientes: [
        { id: "cli001", nombre: "Cliente A (Ejemplo)" },
        { id: "cli002", nombre: "Cliente B (Ejemplo)" },
      ],
      tarifas: {
        fedex: {
          nombre: "FedEx",
          suplementos: [
            { concepto: "Out of Pickup Area Tier B", costoOriginal: 205, tipoValor: "MONEDA" },
            { concepto: "Out of Delivery Area Tier B", costoOriginal: 205, tipoValor: "MONEDA" },
            { concepto: "Declared Value Charge", costoOriginal: 30, tipoValor: "PORCENTAJE" },
            { concepto: "Oversize Charge", costoOriginal: 761.7, tipoValor: "MONEDA" },
            { concepto: "Add'l Handling-Dimension", costoOriginal: 186.21, tipoValor: "MONEDA" },
          ],
        },
        estafeta: {
          nombre: "Estafeta",
          suplementos: [
            { concepto: "Sobrepeso por kilo", costoOriginal: 7.49, tipoValor: "MONEDA" },
            { concepto: "Combustible del Sobrepeso", costoOriginal: 1.47, tipoValor: "MONEDA" },
            { concepto: "Envios Irregulares", costoOriginal: 210, tipoValor: "MONEDA" },
          ],
        },
        paquetexpress: {
          nombre: "Paquetexpress",
          suplementos: [
            { concepto: "Zona Plus", costoOriginal: 210, tipoValor: "MONEDA" },
            { concepto: "Seguro Pak2go", costoOriginal: 1.5, tipoValor: "PORCENTAJE" },
          ],
        },
        dhl: {
          nombre: "DHL",
          suplementos: [
            { concepto: "Zona Extendida", costoOriginal: 210, tipoValor: "MONEDA" },
            { concepto: "Kilogramo adicional", costoOriginal: 30, tipoValor: "PORCENTAJE" },
            { concepto: "Seguro Pak2go", costoOriginal: 1.5, tipoValor: "PORCENTAJE" },
          ],
        },
      },
    };
  },

  computed: {
    clienteSeleccionadoNombre() {
      const c = this.clientes.find(c => c.id === this.clienteSeleccionadoId);
      return c ? c.nombre : "N/A";
    },
  },

  methods: {
    guardarCostos() {
      const payload = {
        clienteId: this.clienteSeleccionadoId,
        tarifas: this.tarifas,
      };

      console.log("Payload listo:", payload);
      alert(`Costos guardados exitosamente para ${this.clienteSeleccionadoNombre}.`);
    },
  },
};
</script>

<style scoped>
.card-header.bg-dark {
  background-color: rgb(44, 46, 120) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TarificadorPersonalizado.vue